import { ofType } from 'redux-observable';
import { filter, map } from 'rxjs';
import { isEmpty, isNil } from 'lodash';
import { AppEpic } from 'src/store';
import { isNotSameExternalDataRefreshRequest } from 'src/utils/Functions/epicsFunctions';
import { REQUEST_EXTERNAL_DATA_REFRESH, requestExternalDataRefresh } from '../higherOrder/GlobalDataRefresh';
import { handleExternalRedecorate } from './HistoryStylePane.slice';
import { STYLE_PANE_COMPONENT } from './HistoryStylePane.types';

/**
 * Bridges external redecorate requests from other views' edits into a Style Pane redecorate.
 * A host view (for example a `ConfigurableGrid`) can be editable while the pane is open over it,
 * and it emits `requestExternalDataRefresh` with the affected style-colors. If the pane is open we
 * dispatch the `handleExternalRedecorate` thunk, which redecorates every row the pane currently
 * shows and splices the results back into the slice.
 *
 * Mirrors `configurableGridExternalRedecorate`. We filter out the pane's own edits via
 * `isNotSameExternalDataRefreshRequest` so the pane doesn't redecorate itself off its own change.
 */
export const historyStylePaneExternalRedecorate: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(REQUEST_EXTERNAL_DATA_REFRESH),
    filter((action) => isNotSameExternalDataRefreshRequest(action, STYLE_PANE_COMPONENT)),
    // only act when the pane is actually open with rows to redecorate
    filter(() => {
      const { currentItem } = state$.value.historyStylePane;
      return !isNil(currentItem) && !isEmpty(currentItem);
    }),
    // the payload scopes which cells get async-state markers while the redecorate is in flight
    map(({ payload }: ReturnType<typeof requestExternalDataRefresh>) => handleExternalRedecorate(payload)),
  );
};
